(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            container: '[data-component="Dom.CallMeBack"]',
            primaryCompanyIdField: '#primaryCompanyId',

            formToggle: '[data-target="call-me-back"]',
            hiddenContactId: '.hidden-contact-id,[value="hidden-contact-id"]'
        },
        classes: {},
        data: {
            companyId: 'company-id'
        },
        events: {
            click: 'click'
        },
        options: {}
    };

    ns.CallMeBackWffm = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.CallMeBackWffm.prototype = {
        init: function() {
            this.cacheItems();
            if (this.container.length) {
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var cache = this.settings.cache,
                data = this.settings.data;

            this.companyId = this.container.data(data.companyId);
            this.hiddenContactId = this.container.find(cache.hiddenContactId);

            this.formToggle = this.container
                .prev()
                .prev()
                .find(cache.formToggle);

            // if (!this.formToggle || !this.formToggle.length) {
            //     this.formToggle = $(cache.formToggle);
            // }
        },
        bindEvents: function() {
            let settings = this.settings,
                events = settings.events;

            this.formToggle.on(events.click, () => {
                this.container.modal();
                return false;
            });
        },
        activate: function() {
            let settings = this.settings,
                data = settings.data;

            let companyId = this.container.data(data.companyId);

            this.hiddenContactId.addClass('hidden-contact-id');

            this.hiddenContactId.val(companyId);
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
